<template>
  <VView class="rules" back-button-to="/menu" header="Zasady">
    <VText>1. Wyślij Przelew na telefon BLIK do fundacji “Zwierzęca Polana” na numer 721&nbsp;225&nbsp;111, aby pomóc  zwierzakom. Więcej informacji o fundacji znajdziesz <a href="https://www.fundacjazwierzecapolana.org/" target="_blank">tutaj.</a></VText>
    <VText>2. Odpowiedz na pytanie “Dlaczego warto według Ciebie czynić dobro?”.</VText>
    <VText>3. Wypełnij formularz osobowy, abyśmy mogli się z Tobą skontaktować w przypadku wygranej. Twoje dane usuniemy po zakończeniu konkursu.</VText>
    <VText>4. Czekaj na wyniki. Sposród wszystkich zgłoszeń jury konkursu wybierze najbardziej kreatywne uzasadnienia i nagrodzi ich autorów zaproszeniami na wspólną kolację z Natalią Kukulską!</VText>
    <VText center>Konkurs trwa od 12.09 do 2.10.2022.<br />Szczegóły znajdziesz w <a :href="$t('app.regulations')" target="_blank">regulaminie.</a></VText>

    <VButtonGroup>
      <!-- <VButton alternative to="/contest">Weź udział!</VButton> -->
      <VButton alternative to="/contest">Laureaci</VButton>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VText from '@/components/VText.vue';
import VMedia from '@/components/VMedia.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'Rules',
  components: {
    VView,
    VText,
    VMedia,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss" scoped>
.rules {
  ::v-deep .button-group {
    margin-top: 100px !important;
  }

  ::v-deep .text {
    font-weight: bold;
  }
}
</style>
